import React, { useRef, useEffect } from 'react';
import { Box, InputBase } from '@mui/material';

export const IndicationField = React.forwardRef(({
  amount,
  value = '',
  onChange,
  errors,
  disabled = false,
  validChars = 'A-Za-z0-9',
  height = '28px',
  width = '19px',
}) => {
  const inputsRef = useRef([]);

  useEffect(() => {
    if (value.length > amount) {
      onChange(value.slice(0, amount));
    }
  }, [value]);

  const handleChange = (index, char) => {
    const regex = new RegExp(`^[${validChars}]$`, 'i');
    if (!regex.test(char) && char !== '') return;

    const newValue = value.split('');
    newValue[index] = char;
    const updated = newValue.join('').padEnd(amount, '');
    onChange(updated);

    if (char && index < amount - 1 && inputsRef.current[index + 1]) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !value[index] && index > 0 && inputsRef.current[index - 1]) {
      inputsRef.current[index - 1].focus();
    }
  };

  return (

    <Box sx={{ display: 'flex', gap: 1 }}>
      {Array.from({ length: amount }).map((_, index) => (
        <InputBase
          key={index}
          inputRef={el => inputsRef.current[index] = el}
          inputProps={{
            maxLength: 1,
            style: {
              textAlign: 'center',
              width: width,
              height: height,
              border: '1px solid #C4C4C4',
              borderRadius: 6,
              backgroundColor: '#fff',
              font: "normal normal bold 16px/30px Roboto",
              color: "#333333"
            }
          }}
          error={errors?.status ? errors?.message : ''}
          disabled={disabled}
          value={value[index] || ''}
          onChange={e => handleChange(index, e.target.value)}
          onKeyDown={e => handleKeyDown(index, e)}
        />
      ))}

    </Box>
  );
});
